import React from "react";
import Slider, { Slide } from "@/components/Slider";
import { VideoSliderItem } from "@/components/PageHome/api/interface";
import SlideCard from "@/components/PageHome/components/VideoSlider/SlideCard";
import { RefsObjectType } from "@/components/PageHome/interfaces";
import styles from "./VideoSlider.module.scss";

interface CarouselProps {
  sliderList?: VideoSliderItem[];
  refs?: RefsObjectType;
}

const VideoSlider: React.FC<CarouselProps> = ({ sliderList, refs }) => {
  return (
    <section data-testid={"VideoSlider"} className={styles.carousel}>
      <Slider
        interval={3000}
        showArrows={false}
        dotsWrapperClass={styles.dotsWrapperClass}
        dotClass={styles.dotClass}
        dotClassActive={styles.dotClassActive}
      >
        {sliderList.map((item: VideoSliderItem, index: number) => (
          <Slide key={item.id} index={index}>
            <SlideCard {...item} refs={refs} />
          </Slide>
        ))}
      </Slider>
    </section>
  );
};

export default VideoSlider;
